import createReactClass from 'create-react-class';
import React from 'react';
import { AutoSizer, Column, SortDirection, Table } from 'react-virtualized';
import { FormRequestActions } from '../actions/formRequestActions';
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { formValidation } from '../util/formValidation';

function getStateFromStores() {
    return {
        isLoading: false,
        disableHeader: false,
        useDynamicRowHeight: false,
        rowCount: 10,
        scrollToIndex: undefined,
        height: 100,
        rowHeight: 23,
        headerHeight: 30,
        overscanRowCount: 10,
        hideIndexRow: false,
        sortDirection: SortDirection.ASC,
        defaultID: 0,
        alertVisible: false,
        alertMessage: '',
        defaultChecked: true,
        previousSub: '',
        previousTab: "true",
        data: restrictionRequestStore.getSubLocations(),
        locationsLoading: restrictionRequestStore.areSubLocationsLoading()
    };
}

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

export const SubdivisionLocationList = createReactClass({

    componentDidMount: function () {
        restrictionRequestStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        restrictionRequestStore.unsubscribe(this._onChange);
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    _getRowHeight({ index }) {
        const { list } = this.context;

        return this._getDatum(list, index).size
    },

    _updateUseDynamicRowHeight(value) {
        this.setState({
            useDynamicRowHeight: value
        })
    },

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow"
        } else {
            return index % 2 === 0 ? "oddRow" : "evenRow"
        }
    },
    _noRowsRenderer() {
        var noRow;
        if (this.state.locationsLoading) {
            noRow = "Loading ..."
        } else {
            noRow = "No rows found"
        }
        return (
            <div className="issuedNoRows">
                {noRow}
            </div>
        )
    },

    noTabRowRenderer(_ref) {
        var className = _ref.className,
            columns = _ref.columns,
            index = _ref.index,
            key = _ref.key,
            onRowClick = _ref.onRowClick,
            onRowDoubleClick = _ref.onRowDoubleClick,
            onRowMouseOut = _ref.onRowMouseOut,
            onRowMouseOver = _ref.onRowMouseOver,
            onRowRightClick = _ref.onRowRightClick,
            rowData = _ref.rowData,
            style = _ref.style;

        var a11yProps = {};

        if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
            a11yProps['aria-label'] = 'row';
            a11yProps.tabIndex = null;

            if (onRowClick) {
                a11yProps.onClick = function (event) {
                    return onRowClick({ event: event, index: index, rowData: rowData });
                };
            }
            if (onRowDoubleClick) {
                a11yProps.onDoubleClick = function (event) {
                    return onRowDoubleClick({ event: event, index: index, rowData: rowData });
                };
            }
            if (onRowMouseOut) {
                a11yProps.onMouseOut = function (event) {
                    return onRowMouseOut({ event: event, index: index, rowData: rowData });
                };
            }
            if (onRowMouseOver) {
                a11yProps.onMouseOver = function (event) {
                    return onRowMouseOver({ event: event, index: index, rowData: rowData });
                };
            }
            if (onRowRightClick) {
                a11yProps.onContextMenu = function (event) {
                    return onRowRightClick({ event: event, index: index, rowData: rowData });
                };
            }
        }

        return React.createElement(
            'div',
            _extends({}, a11yProps, {
                id: 'locationTable',
                className: className,
                key: key,
                role: 'row',
                style: style
            }),
            columns
        );
    },

    _onRowClick: function (data) {
        FormRequestActions.formCLocationSelection(this.props.locationType, data.rowData.locationId.trim());
        if (this.props.locationType === 'from') {
            $('#toLocation').focus();
        }
        else if (this.props.locationType === 'to') {
            $('#authorizedBy').focus()
        }
    },

    _getDatum(list, index) {
        return list.get(index % list.size)
    },

    formatValue({
        cellData,
        columnData,
        columnIndex,
        dataKey,
        isScrolling,
        rowData,
        rowIndex
    }) {
        if (dataKey === "milepost") {
            return formatMp(cellData) + (rowData.suffix ? rowData.suffix : '')
        }
    },

    render: function () {
        const {
            rowHeight,
            headerHeight,
            overscanRowCount,
            sortBy,
            sortDirection
        } = this.state;

        let list = this.state.data;
        let gridForm = (<div style={{ height: '100%' }}>
            <AutoSizer>
                {({ height, width }) => (
                    <Table ref='Table' id="locationTable" disableHeader={false} width={width} height={height}
                        headerHeight={headerHeight} rowHeight={rowHeight} overscanRowCount={overscanRowCount} rowCount={list.length} rowClassName={this._rowClassName}
                        sortBy={sortBy} sortDirection={sortDirection} noRowsRenderer={this._noRowsRenderer} onRowClick={this._onRowClick} rowRenderer={this.noTabRowRenderer} rowGetter={({ index }) => list[index]} tabIndex={-1} >

                        <Column width={width * .10} label='Seq' dataKey='locationSequence' />
                        <Column width={width * .45} label='Loc Id' dataKey='locationId' />
                        <Column width={width * .25} label='Stn 333' dataKey='station333' />
                        <Column width={width * .08} label='St' dataKey='stationState' />
                        <Column width={width * .12} label='Mp' dataKey='milepost' cellRenderer={this.formatValue} />

                    </Table>)}

            </AutoSizer>
        </div>);
        return (
            <div style={{ height: '100%' }}>
                {gridForm}
            </div>
        );
    },
});

function formatMp(mp) {
    var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);

    if (mpRegexNoDecimal.test(mp)) {
        return mp + '.0';
    }
    return mp
}